import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { IconModule } from '@spartacus/storefront'
import { SharedModule } from '../../../shared/shared.module'
import { NewCreditClaimPhotoUploadModalComponent } from './new-credit-claim-photo-upload-modal.component'

@NgModule({
  declarations: [NewCreditClaimPhotoUploadModalComponent],
  imports: [CommonModule, SharedModule, IconModule, ReactiveFormsModule]
})
export class NewCreditClaimPhotoUploadModalModule {}
